export default "__VITE_ASSET__H$P3AuLK__";